import { Link } from "react-router-dom"
import React, { useState } from "react"
import Menu from "../menu"
import Search from "../search"

export default function NavBar() {
  const [menuVisibility, setMenuVisibility] = useState(false)

  const showMenu = () => {
    setMenuVisibility(true)
  }

  const hideMenu = () => {
    setMenuVisibility(false)
  }

  return (
    <nav className="nav-bar">
      {menuVisibility && (
        <div className="menu-container d-flex">
          <Menu />
          <div className="hide-menu-box" onClick={hideMenu}></div>
        </div>
      )}
      <div className="nav-bar-top">
        <div className="menu-box" onClick={showMenu}>
          <ion-icon
            name="list"
            style={{ fontSize: "35px", color: "black" }}
          ></ion-icon>
        </div>
        <div className="nav-logo">
          <Link to="/">
            <img
              src="https://sabjigrocery.web.app/static/media/logo.a64fdfed.png"
              alt="sabjigrocery logo"
            />
          </Link>
        </div>
      </div>
    </nav>
  )
}
